import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import React, { Component } from 'react';
import StaticContainer from 'react-static-container';
import { bindActionCreators } from 'redux';
import get from 'lodash/get';
import ScriptLoader from 'yoda-core-components/lib/helpers/ScriptLoader/ScriptLoader';
import LocalStorage from 'yoda-core-components/lib/helpers/LocalStorage/LocalStorage';
import {
    selectPreferences,
    selectFeatureFlags,
} from 'yoda-site-components/lib/selectors/ContextSelector';
import User from 'yoda-site-components/lib/helpers/User/User';
import { openSignInSlider } from 'yoda-site-components/lib/actions/AccountAction';
import { BVReviewsLoaded } from 'yoda-site-components/lib/actions/BVReviewsAction';

import { libraryLoading, libraryLoaded } from '../../actions/BazaarVoiceAction';
import { removeAndScrollSubmissionForm } from '../../helpers/BazaarVoice';
import signinFrom from '../../actions/SignInSliderAction';

const USER_TOKEN_KEY = 'DP_USER_TOKEN';
const bvContentTypes = ['reviews', 'qa', 'photos'];
let doLoginCallBack = '';

let contentRenderedOnce = false;
let scrollToQuestions = false;
let scrollToReview = false;
export class BazaarVoice extends Component {
    static defaultProps = {
        actions: {},
        submissionContainerId: null,
        bazaarvoice: {},
        preferences: {},
        featureFlags: {},
        authenticationSuccess: false,
        signinSliderFrom: '',
        isSigninSlider: false,
        onCancel: null,
        BVReviews: {
            isLoaded: false,
        },
    };

    static propTypes = {
        contentType: PropTypes.oneOf(bvContentTypes).isRequired,
        submissionContainerId: PropTypes.string,
        actions: PropTypes.oneOfType([PropTypes.object]),
        bazaarvoice: PropTypes.oneOfType([PropTypes.object]),
        preferences: PropTypes.oneOfType([PropTypes.object]),
        featureFlags: PropTypes.oneOfType([PropTypes.object]),
        authenticationSuccess: PropTypes.bool,
        signinSliderFrom: PropTypes.string,
        isSigninSlider: PropTypes.bool,
        onCancel: PropTypes.func,
        BVReviews: PropTypes.object,
    };

    constructor(props) {
        super(props);
        this.state = {
            toBeConfigured: false,
            configured: false,
        };
    }

    componentDidMount() {
        this.loadBV();
        this.setState({ toBeConfigured: true }); // eslint-disable-line react/no-did-mount-set-state
    }

    shouldComponentUpdate(nextProps, nextState) {
        /* istanbul ignore if */
        if (
            this.props.authenticationSuccess &&
            (this.props.signinSliderFrom === 'askAQuetion' ||
                this.props.signinSliderFrom === 'writeAReview') &&
            this.props.isSigninSlider !== nextProps.isSigninSlider
        ) {
            const userToken = this.getUserToken();
            doLoginCallBack && doLoginCallBack(userToken);
        }

        if (nextState.toBeConfigured && nextProps.bazaarvoice.loaded) {
            this.configure();
        }

        if (nextState.configured !== this.state.configured) {
            return true;
        }

        return false;
    }

    componentDidUpdate() {
        const { featureFlags } = this.props;
        !this.props.BVReviews.isloaded && this.props.actions.BVReviewsLoaded();
        /* istanbul ignore next */
        !contentRenderedOnce &&
            !__SERVER__ &&
            get(featureFlags, 'enableDesktopAccordionBV', true) &&
            window &&
            window.$BV &&
            window.$BV.configure &&
            window.$BV.configure('global', {
                events: {
                    bvRender(data) {
                        const bvQuestionsBtnAll = document.querySelectorAll(
                            "[data-content-type='question']"
                        );
                        const bvReviewsBtnAll = document.querySelectorAll(
                            "[data-content-type='review']"
                        );
                        const bvAccordionContainer = document.querySelector(
                            "[data-automation-id='product-info-accordion']"
                        );
                        const bvQuestionsContainer =
                            bvAccordionContainer &&
                            bvAccordionContainer.querySelector('#accordion-button-1');
                        const bvReviewsContainer =
                            bvAccordionContainer &&
                            bvAccordionContainer.querySelector('#accordion-button-0');
                        function scrollToQA() {
                            const isQAExpanded =
                                bvQuestionsContainer &&
                                bvQuestionsContainer.getAttribute('aria-expanded');
                            isQAExpanded === 'false' &&
                                bvQuestionsContainer &&
                                bvQuestionsContainer.click();
                            scrollToQuestions = true;
                        }
                        function scrollToReviews() {
                            const isReviewsExpanded =
                                bvReviewsContainer &&
                                bvReviewsContainer.getAttribute('aria-expanded');
                            isReviewsExpanded === 'false' &&
                                bvReviewsContainer &&
                                bvReviewsContainer.click();
                            scrollToReview = true;
                        }
                        if (data?.method === 'rr_show_reviews' && !scrollToReview) {
                            bvQuestionsBtnAll.forEach((ele) => {
                                ele.addEventListener('click', scrollToQA);
                            });
                        } else if (scrollToQuestions) {
                            const bvQuestionsBtn = document.querySelector(
                                "[data-content-type='question']"
                            );
                            bvQuestionsBtn && bvQuestionsBtn.click();
                            scrollToQuestions = false;
                            bvQuestionsBtnAll.forEach((ele) => {
                                ele.removeEventListener('click', scrollToQA);
                            });
                        } else if (data?.method === 'rr_show_reviews' && scrollToReview) {
                            const bvReviewsBtn = document.querySelector(
                                "[data-content-type='review']"
                            );
                            bvReviewsBtn && bvReviewsBtn.click();
                            scrollToReview = false;
                            bvReviewsBtnAll.forEach((ele) => {
                                ele.removeEventListener('click', scrollToReview);
                            });
                        } else {
                            bvReviewsBtnAll.forEach((ele) => {
                                ele.addEventListener('click', scrollToReviews);
                            });
                        }
                    },
                },
            });
        if (!contentRenderedOnce) {
            contentRenderedOnce = true;
        }
    }

    onSubmissionReturn(type) {
        removeAndScrollSubmissionForm({
            formAction: 'Cancel',
            eType: 'Write',
            eventTarget: type,
        });
        this.props.onCancel && this.props.onCancel();
        return false;
    }

    getBVUrl = () => {
        let productType = '';
        productType = 'allProducts';
        const bvURL = get(this.props.preferences, `bazaarVoice.${productType}`);

        if (!bvURL) {
            console.error('Please add bazaar voice urls to the configuration');
        }

        return bvURL;
    };

    // eslint-disable-next-line class-methods-use-this
    getUserToken() {
        if (User.isUserLoggedIn(true)) {
            return LocalStorage.getData(USER_TOKEN_KEY);
        }
        return false;
    }

    doLogin = (successCallBack, successUrl) => {
        const { contentType, featureFlags, actions } = this.props;
        const userToken = this.getUserToken();
        /* istanbul ignore else */
        if (userToken) {
            successCallBack(userToken);
        } else if (get(featureFlags, 'enableSignInSlider', true)) {
            doLoginCallBack = successCallBack;
            if (contentType === 'qa') {
                actions.signinFrom({ clickFrom: 'askAQuetion' });
                actions.openSignInSlider(false);
            } else if (contentType === 'reviews') {
                actions.signinFrom({ clickFrom: 'writeAReview' });
                actions.openSignInSlider(false);
            } else {
                window.location =
                    `${window.location.protocol}//${window.location.hostname}/` +
                    `signin?next=${encodeURIComponent(successUrl)}`;
            }
        } else {
            window.location =
                `${window.location.protocol}//${window.location.hostname}/` +
                `signin?next=${encodeURIComponent(successUrl)}`;
        }
    };

    configure = () => {
        const { contentType } = this.props;
        switch (contentType) {
            case 'reviews':
                this.configureReviews();
                break;
            case 'qa':
                this.configureQA();
                break;
            case 'photos':
                this.configurePhotos();
                break;
            default:
        }
    };

    bazaarvoiceEvent = (json) => {
        if (!this.state.configured && json.eventSource === 'Display' && json.eType === 'Read') {
            this.setState({
                configured: true,
                toBeConfigured: false,
            });
        } else if (json.eName === 'Paginate') {
            removeAndScrollSubmissionForm(json);
        }
    };

    configureReviews = () => {
        window.bvCallback = (BV) => {
            if (BV && BV.swat_reviews) {
                BV.swat_reviews.on('container_added', () => {
                    this.setState({
                        configured: true,
                        toBeConfigured: false,
                    });
                });
            } else if (BV && BV.reviews) {
                BV.reviews.on('container_added', () => {
                    this.setState({
                        configured: true,
                        toBeConfigured: false,
                    });
                });
            }
        };
    };

    configureQA = () => {
        window.bvCallback = (BV) => {
            if (BV && BV.swat_questions) {
                BV.swat_questions.on('container_added', () => {
                    this.setState({
                        configured: true,
                        toBeConfigured: false,
                    });
                });
            } else if (BV && BV.questions) {
                BV.questions.on('container_added', () => {
                    this.setState({
                        configured: true,
                        toBeConfigured: false,
                    });
                });
            }
        };
    };

    // eslint-disable-next-line react/sort-comp
    configurePhotos = this.configureReviews;

    loadScript = () => {
        const { actions } = this.props;
        const bvURL = this.getBVUrl();

        if (this.getBVUrl) {
            const bazzarVoiceLibProps = {
                src: bvURL,
                async: true,
                defer: false,
                onSuccess: actions.libraryLoaded,
            };

            ScriptLoader.load(bazzarVoiceLibProps);

            actions.libraryLoading();
        }
    };

    loadBV = () => {
        const { bazaarvoice } = this.props;
        if (!bazaarvoice.loaded && !bazaarvoice.loading) {
            this.loadScript();
        }
    };

    // eslint-disable-next-line class-methods-use-this
    doScrollSubmission() {
        return false;
    }

    render() {
        const { submissionContainerId } = this.props;
        return (
            <>
                <StaticContainer>
                    <>{submissionContainerId && <div id={submissionContainerId} />}</>
                </StaticContainer>
            </>
        );
    }
}

const mapDispatchToProps = (dispatch) => ({
    actions: bindActionCreators(
        {
            libraryLoading,
            libraryLoaded,
            openSignInSlider,
            signinFrom,
            BVReviewsLoaded,
        },
        dispatch
    ),
});

const mapStateToProps = (state) => ({
    bazaarvoice: state.bazaarvoice,
    preferences: selectPreferences(state),
    featureFlags: selectFeatureFlags(state),
    authenticationSuccess:
        state.signInSliderDetails && state.signInSliderDetails.authenticationSuccess,
    signinSliderFrom:
        state.signInSliderFrom && state.signInSliderFrom.clickFrom
            ? state.signInSliderFrom.clickFrom
            : '',
    isSigninSlider: (state.accounts && state.accounts.openSignInSlider) || false,
    BVReviews: state.BVReviews,
});

export default connect(mapStateToProps, mapDispatchToProps)(BazaarVoice);
